import { createStore } from "vuex";

export default createStore({
  state: { test: "ciao" },
  mutations: {},
  actions: {},
  modules: {},
});
